var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9987 34.486C12.5345 34.486 1.27566 18.4273 3.51709 14.4006C8.29874 5.81098 17.4701 0 27.9987 0C38.5545 0 47.7458 5.84084 52.5171 14.467C54.7358 18.4781 43.4629 34.486 27.9987 34.486Z",
    fill: "#6DDBAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 30.8493 55.5744 33.599 54.7828 36.189C54.2325 37.9903 53.5061 39.7143 52.6226 41.3416C51.7203 43.0041 36.5017 46.7447 28 46.7447C19.4983 46.7447 4.27973 43.0041 3.3787 41.3416C3.01897 40.6819 2.68614 40.0061 2.38109 39.3147C0.849844 35.8553 0 32.0272 0 28C0 22.9448 1.33984 18.2033 3.68375 14.1094C8.50948 22.5389 17.5919 28.2187 28 28.2187C38.4081 28.2187 47.4918 22.5389 52.3162 14.1094C54.6602 18.2033 56 22.9448 56 28Z",
    fill: "#4DC591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6393 41.3108C51.8562 42.7571 50.9512 44.1263 49.9353 45.4047C49.0125 46.5677 47.9972 47.6545 46.9035 48.6556C44.949 50.4453 42.7396 51.9614 40.3361 53.143C36.6146 54.9724 19.3167 54.9549 15.5715 53.0961C13.2047 51.9214 11.0278 50.4218 9.09912 48.6556C8.00537 47.6545 6.99016 46.5677 6.06736 45.4047C5.05137 44.1263 4.14641 42.7571 3.36328 41.3108H52.6393Z",
    fill: "#4DC591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.106 46.5429L27.2969 44.436V52.8634L34.3197 50.7566C31.9925 50.7566 30.106 48.87 30.106 46.5429Z",
    fill: "#FF8B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8915 46.5429C25.8915 48.87 24.005 50.7566 21.6777 50.7566L27.9983 52.8634V44.436L25.8915 46.5429Z",
    fill: "#FFB952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0409 45.9289L27.4269 46.5429C27.4269 48.8701 26.0801 50.7566 25.0625 50.7566L28.0409 52.3659V45.9289Z",
    fill: "#FFA725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9586 53.4114C38.0495 51.827 36.3419 50.7566 34.3878 50.7566H27.997L23.7832 53.3901L27.9583 55.9996C27.9712 55.9996 27.9841 56.0001 27.997 56.0001C31.9382 56.0001 35.661 55.0669 38.9586 53.4114Z",
    fill: "#FFA725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6079 50.7566C19.6538 50.7566 17.9462 51.827 17.0371 53.4114C20.3347 55.0669 24.0575 56.0001 27.9987 56.0001V50.7566H21.6079Z",
    fill: "#FFD04F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8868 50.7566C23.3662 50.7566 21.2545 52.5367 20.7402 54.9055C23.0334 55.6168 25.4709 56.0001 27.998 56.0001V50.7566H25.8868Z",
    fill: "#FFC320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3109 34.8826C16.8183 34.8336 14.4827 33.8259 12.7345 32.0452C10.9838 30.262 10.0195 27.9034 10.0195 25.4041V24.2804C10.0195 21.957 11.9098 20.0667 14.2333 20.0667C16.5568 20.0667 18.447 21.9569 18.447 24.2804H16.3402C16.3402 23.1187 15.3951 22.1736 14.2334 22.1736C13.0717 22.1736 12.1265 23.1187 12.1265 24.2804V25.4041C12.1265 29.3907 15.3681 32.6978 19.3525 32.7762L19.3109 34.8826Z",
    fill: "#FFC320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.686 34.8826L36.6445 32.7762C40.6289 32.6978 43.8705 29.3907 43.8705 25.4041V24.2804C43.8705 23.1187 42.9254 22.1736 41.7637 22.1736C40.602 22.1736 39.6568 23.1187 39.6568 24.2804H37.55C37.55 21.957 39.4403 20.0667 41.7638 20.0667C44.0872 20.0667 45.9775 21.9569 45.9775 24.2804V25.4041C45.9775 27.9034 45.0133 30.262 43.2625 32.0452C41.5142 33.8259 39.1786 34.8336 36.686 34.8826Z",
    fill: "#FFA725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1043 43.3824H27.9975L25.8906 45.4893L27.9975 47.5962H30.1043C31.2679 47.5962 32.2111 46.6529 32.2111 45.4894C32.2111 44.3259 31.2679 43.3824 30.1043 43.3824Z",
    fill: "#FFA725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.892 43.3825C24.7284 43.3825 23.7852 44.3258 23.7852 45.4894C23.7852 46.653 24.7284 47.5962 25.892 47.5962H27.9988V43.3824H25.892V43.3825Z",
    fill: "#FFD04F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5424 43.3825C26.3788 43.3825 25.4355 44.3258 25.4355 45.4894C25.4355 46.653 26.3788 47.5962 27.5424 47.5962H27.9989V43.3824H27.5424V43.3825Z",
    fill: "#FFC320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9981 24.2805L23.082 33.8316L27.9981 43.3826C32.5391 43.3826 36.4781 40.1546 37.3644 35.7071L39.6416 24.2804H27.9981V24.2805Z",
    fill: "#FF8B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3555 24.2804L18.6327 35.7071C19.519 40.1545 23.458 43.3826 27.999 43.3826V24.2804H16.3555Z",
    fill: "#FFB952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1577 24.2804H21.4727L23.3106 36.0084C23.8459 38.6946 25.7741 42.0286 27.9967 43.3825L28.1577 24.2804Z",
    fill: "#FFA725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0064 5.54767H30.8397C30.101 5.54767 29.5025 4.94862 29.5025 4.21034V4.04376H28.5493V4.21034C28.5493 4.94862 27.9502 5.54767 27.2119 5.54767H27.0449V6.50087H27.2119C27.9502 6.50087 28.5493 7.09937 28.5493 7.83809V8.00521H29.5025V7.83809C29.5025 7.09937 30.101 6.50087 30.8397 6.50087H31.0064V5.54767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6822 14.4009H36.5155C35.7768 14.4009 35.1783 13.8018 35.1783 13.0636V12.897H34.225V13.0636C34.225 13.8018 33.626 14.4009 32.8877 14.4009H32.7207V15.3541H32.8877C33.626 15.3541 34.225 15.9526 34.225 16.6913V16.8584H35.1783V16.6913C35.1783 15.9526 35.7768 15.3541 36.5155 15.3541H36.6822V14.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4673 9.98596H21.3006C20.5619 9.98596 19.9634 9.38691 19.9634 8.64863V8.48206H19.0102V8.64863C19.0102 9.38691 18.4112 9.98596 17.6729 9.98596H17.5059V10.9392H17.6729C18.4112 10.9392 19.0102 11.5377 19.0102 12.2764V12.4435H19.9634V12.2764C19.9634 11.5377 20.5619 10.9392 21.3006 10.9392H21.4673V9.98596Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.7cd93ceb2dabd909d86414c77a2f494a.svg";
export { ForwardRef as ReactComponent };